import { render, staticRenderFns } from "./illustration.vue?vue&type=template&id=d62aef36"
import script from "./illustration.vue?vue&type=script&lang=js"
export * from "./illustration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports